export default __webpack_public_path__ + "static/media/m_engineering_card19_1.101ff81f.png";